import { makeAutoObservable } from "mobx";

export default class AdPosition {
  itemDatas = localStorage.getItem("billing_report_itemDatas") || "{}";
  id = localStorage.getItem("billing_report_id") || "";
  constructor () {
    /**
     * state
     */
    this.itemDatas = localStorage.getItem("billing_report_itemDatas") || "{}";
    this.id = localStorage.getItem("billing_report_id") || "";
    makeAutoObservable(this);
  }

  /**
   * computed
   */
  get billingItemDatas () {
    return JSON.parse(this.itemDatas);
  }

  get reportId () {
    return this.id;
  }

  /**
   * action
   */
  setItemDatas (datas: any) {
    const itemDatas = JSON.stringify(datas);
    this.itemDatas = itemDatas;
    this.id = datas.id;
    localStorage.setItem("billing_report_itemDatas", itemDatas);
    localStorage.setItem("billing_report_id", datas.id);
  }
}
